import styled, { css } from 'styled-components';

export const StyledHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 3.2rem;
  line-height: 1.149;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  margin: 3.2rem 0 2rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 2.8rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: 2.4rem;
  }
`;

export const StyledDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2rem;
  line-height: 1.257;
  text-align: left;
  color: ${({ theme }) => theme.colors.grey[400]};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin: 0;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 1.8rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: 1.6rem;
  }
`;

export const StyledGradientBg = css`
  &::before {
    content: '';
    background: radial-gradient(circle at center, rgba(28, 77, 169, 1) 0%, rgba(21, 28, 43, 0) 70%);
    border-radius: 100px;
    filter: blur(100px);
    height: 100%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    width: 100%;
    z-index: 0;
  }
`;
